/* eslint-disable default-param-last */
import { SET_GIN_LOADING, SET_GIN_USERCART, CLEAR_GIN_USERCART, SET_GIN_DISCOUNT_STR, SET_GIN_RECURRING_DISCOUNT_STR, SET_GIN_PRICING, SET_GIN_NEXT_ORDER, } from "../actions/types";
const initialState = {
    loading: false,
    userCart: [],
    pricingSummary: [],
    discountStr: [],
    recurringDiscountStr: null,
    nextOrderData: {
        deliverydate1: "",
        deliverydate2: "",
        hasSubscription: false,
        nextBillDate: "",
        nextShipmentDay: 0,
        nextShipmentMonth: 0,
        nextShipmentYear: 0,
        needsToProvidePauseReason: false,
        nextOrderSkipped: false,
    },
};
export default function getItNowReducer(state = initialState, action) {
    switch (action.type) {
        case SET_GIN_LOADING: {
            return {
                ...state,
                loading: action.payload,
            };
        }
        case SET_GIN_USERCART: {
            return {
                ...state,
                userCart: action.payload,
            };
        }
        case CLEAR_GIN_USERCART: {
            return {
                ...state,
                userCart: initialState.userCart,
            };
        }
        case SET_GIN_DISCOUNT_STR: {
            return {
                ...state,
                discountStr: action.payload,
            };
        }
        case SET_GIN_RECURRING_DISCOUNT_STR: {
            return {
                ...state,
                recurringDiscountStr: action.payload,
            };
        }
        case SET_GIN_PRICING: {
            return {
                ...state,
                pricingSummary: action.payload,
            };
        }
        case SET_GIN_NEXT_ORDER: {
            return {
                ...state,
                nextOrderData: action.payload,
            };
        }
        default:
            return state;
    }
}
